import { BehaviorSubject } from 'rxjs';

import { handleResponse } from '../_helpers';
import AppCache from '../_helpers/appCache';

const currentDataSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentData')));
const tokenInfoSubject = new BehaviorSubject(currentDataSubject.value ? currentDataSubject.value.access_token : currentDataSubject.value);
export const authenticationService = {
    login,
    logout,
    resetPassword,
    currentData: currentDataSubject.asObservable(),
    tokenInfo: tokenInfoSubject.asObservable(),
    get currentDataValue() { return currentDataSubject.value },
    get tokenInfoValue() { return tokenInfoSubject.value }
};

function login(username, password) {
    let data = {
        'username': username,
        'password': password,
        'grant_type': 'password',
        'scope': '1',
    }
    let formBody = [];
    for (let property in data) {
        let encodedKey = encodeURIComponent(property);
        let encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: formBody
    };

    return fetch(`${process.env.REACT_APP_MAIN_API}/token`, requestOptions)
        .then(handleResponse)
        .then(data => {
            if (data.user) {
                let u = JSON.parse(data.user);
                let user =
                {
                    userId: u.UserID || u.userID,
                    firstName: u.FirstName || u.firstName,
                    lastName: u.LastName || u.lastName,
                    email: u.Email || u.email,
                    roleId: u.RoleID || u.roleID,
                    partnerId: u.PartnerID || u.partnerID,
                    partnerName: u.PartnerName || u.partnerName
                };
                data.user = JSON.stringify(user);
            }
            localStorage.setItem('currentData', JSON.stringify(data));
            currentDataSubject.next(data);
            // tokenInfoSubject.next(user);
            return data;
        }, error => {
            return error('Username or password incorrect');
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentData');
    currentDataSubject.next(null);
    AppCache.clearPartner();
    // tokenInfoSubject.next(null);
}

function resetPassword(email) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    //return fetch(`https://secure.bowwave.com/DefinitiveAPI.Core/api/User/ResetPassword?email=${email}`, requestOptions)
   // return fetch(`https://api.definitivechoice.com/qa-definitiveapi.core/api/User/ResetPassword?email=${email}`, requestOptions)
    return fetch(`${process.env.REACT_APP_MAIN_API}/api/User/ResetPassword?email=${email}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        }, error => {
            return error('Something went wrong while trying to reset your password.');
        });
}
